export default __webpack_public_path__ + "static/media/mixkit-retro-game-notification-212.b222ebf0.wav";